import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, IconButton, Typography, Card, CardActions, CardContent, CardHeader, } from '@mui/material';
import { styled } from '@mui/material/styles';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import Avatar from '@mui/material/Avatar';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import { bgColorLight, white } from '../../tss/colors';
import NoteCreateOrEdit from './NoteCreateOrEdit';
import NoteTitle from './NoteTitle';
const StyledCardContent = styled(CardContent)(() => ({
    paddingTop: 0.25,
    '&:last-child': {
        paddingBottom: 0.25,
    },
}));
const Note = observer(({ note, requestView, requestDelete, requestSave, }) => {
    const [editMode, setEditMode] = useState(false);
    const [name, setName] = useState(note.name);
    const [content, setContent] = useState(note.content);
    const handleViewNote = () => {
        requestView(note);
    };
    const handleSave = () => {
        requestSave(note, {
            name,
            content,
        });
        setEditMode(false);
    };
    const handleCancel = () => {
        setName(note.name);
        setContent(note.content);
        setEditMode(false);
    };
    const courseItemDetails = name?.split('/') || [];
    //   const courseName = courseItemDetails[0];
    const courseItemName = courseItemDetails[1];
    //   const courseItemType = courseItemDetails[2];
    const courseItemPosition = courseItemDetails[3];
    const avatarStyle = {
        width: '32px',
        height: '32px',
        border: `2px solid ${bgColorLight}`,
        color: bgColorLight,
        backgroundColor: white,
    };
    return (_jsx(Card, { sx: { boxShadow: 0 }, children: editMode ? (_jsxs(_Fragment, { children: [_jsx(CardHeader, { title: _jsx(NoteTitle, { title: courseItemName }), sx: { p: 1.5, pt: 0.25 } }), _jsx(CardContent, { sx: { p: 0 }, children: _jsx(NoteCreateOrEdit, { value: content, handleFocus: () => { }, handleChange: (value) => setContent(value), handleSave: handleSave, handleCancel: handleCancel }) })] })) : (_jsxs(_Fragment, { children: [_jsx(CardHeader, { title: _jsx(NoteTitle, { title: courseItemName }), subheader: (_jsxs(CardActions, { sx: {
                            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', p: 0, mt: 0.5,
                        }, children: [_jsxs(Box, { sx: { display: 'flex', flexDirection: 'row' }, children: [_jsx(IconButton, { onClick: handleViewNote, size: "small", "aria-label": "View Note", sx: { p: 0, mr: 1 }, children: _jsx(PlayCircleOutlineIcon, { sx: {
                                                width: '45px',
                                                height: '45px',
                                                color: (t) => t.portal?.courseDeliveryPage?.notesBoxIconColor || t.palette.contract.main,
                                            } }) }), _jsx(Typography, { variant: "subtitle1", fontWeight: "fontWeightBold", sx: {
                                            mt: 'auto',
                                            mb: 'auto',
                                            color: (t) => t.portal?.courseDeliveryPage?.notesBoxTextColor || t.palette.contract.main,
                                        }, children: courseItemPosition })] }), _jsxs(Box, { children: [_jsx(IconButton, { onClick: () => setEditMode(true), size: "small", "aria-label": "Edit Note", children: _jsx(Avatar, { sx: {
                                                ...avatarStyle,
                                                color: (t) => t.portal?.courseDeliveryPage?.notesBoxIconColor || t.palette.contract.main,
                                                borderColor: (t) => t.portal?.courseDeliveryPage?.notesBoxIconColor || t.palette.contract.main,
                                            }, children: _jsx(CreateIcon, {}) }) }), _jsx(IconButton, { onClick: () => requestDelete(note), size: "small", "aria-label": "Delete Note", children: _jsx(Avatar, { sx: {
                                                ...avatarStyle,
                                                color: (t) => t.portal?.courseDeliveryPage?.notesBoxIconColor || t.palette.contract.main,
                                                borderColor: (t) => t.portal?.courseDeliveryPage?.notesBoxIconColor || t.palette.contract.main,
                                            }, children: _jsx(DeleteIcon, {}) }) })] })] })), sx: { p: 1.5, pb: 0.25 } }), _jsx(StyledCardContent, { children: _jsx(Typography, { variant: "caption", sx: {
                            lineHeight: 1,
                            color: (t) => t.portal?.courseDeliveryPage?.notesBoxTextColor || t.palette.contract.main,
                        }, children: note.content }) })] })) }));
});
export default Note;
//# sourceMappingURL=Note.js.map